import { PrintableDocument } from "@redotech/redo-fulfillment-group-common/print-job";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const markAsPrinted = {
  name: "markAsPrinted" as const,
  input: z.object({
    document: createEnum(PrintableDocument),
    workstationId: z.string().optional(),
    unprint: z.boolean().nullish(),
    groups: z.union([
      z.object({ fulfillmentGroupIds: z.array(z.string()) }),
      z.object({ batchId: z.string() }),
    ]),
    // Generated PDF url for the printed document. Present only on real prints
    // (browser modal); used to decrement tracked supplies inventory.
    url: z.string().optional(),
  }),
  output: z.object({}),
};
